import { render, staticRenderFns } from "./ReClientNoteMsg.vue?vue&type=template&id=64de1548&scoped=true"
import script from "./ReClientNoteMsg.vue?vue&type=script&lang=js"
export * from "./ReClientNoteMsg.vue?vue&type=script&lang=js"
import style0 from "./ReClientNoteMsg.vue?vue&type=style&index=0&id=64de1548&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64de1548",
  null
  
)

export default component.exports